import { PropsWithChildren, createContext, useState } from "react";
export interface ScannerContext {
	isScanning: boolean;
	setIsScanning: (isScanning: boolean) => void;
}

export const ScannerContext = createContext<ScannerContext>({} as ScannerContext);
ScannerContext.displayName = "ScannerContext";

export const ScannerProvider: React.FunctionComponent<PropsWithChildren> = (props) => {
	const [isScanning, setIsScanning] = useState(false);
	const value: ScannerContext = {
		isScanning,
		setIsScanning
	};
	return <ScannerContext.Provider value={value}>{props.children}</ScannerContext.Provider>;
};
